export function initSignupForm() {
	moveSubmitButtons();
}

function moveSubmitButtons() {
	$(function () {
		let $parent = $('section .signup-form');
		if ($parent.length > 0) {
			$parent.each((_index, element) => {
				const submitButtonContainer = $(element).find('.wpforms-submit-container');
				const fieldContainer = $(element).find('.wpforms-field-container');
				$(element).find('.wpforms-submit-container').addClass('wpforms-one-third');
				submitButtonContainer.appendTo(fieldContainer);
				$(element).find('.wpforms-submit').html('Sign me up');
				$(element)
					.find('.wpforms-field-email input[type="email"]')
					.addClass('form-control');
			});
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/components/signupForm.ts